module.exports = __webpack_public_path__ + "img/map@2x.30dbd9d5.png";